const ITEM_CUSTOM_PACKING_TYPE = {
  fruitBox: {
    name: 'FRUIT_BOX',
    icon: '🍌🍊',
    showQuantity: true,
  },
  vegetableBox: {
    name: 'VEGETABLE_BOX',
    icon: '🥦🥕',
    showQuantity: true,
  },
  bakery: {
    name: 'BAKERY',
    icon: '🍞',
    showQuantity: false,
  },
  frozen: {
    name: 'FROZEN',
    icon: '❄️',
    showQuantity: false,
  },
  otherQuantity: {
    name: 'OTHER_QUANTITY',
    icon: '',
    showQuantity: true,
  },
  otherBoolean: {
    name: 'OTHER_BOOLEAN',
    icon: '',
    showQuantity: false,
  },
};

export default ITEM_CUSTOM_PACKING_TYPE;
